// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Svh6g","title":"Navbar_title__OYzIK"};